import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AulasSection } from '@/app/aulas/AulasSection';

/**
 * Layout sem caminho próprio das telas internas de Aulas — player,
 * histórico e favoritos: menu de atalhos e temas à esquerda, e a barra
 * lateral principal recolhida para dar largura ao conteúdo.
 */
export const Route = createFileRoute('/_app/cursos/_painel')({
  staticData: { compactNav: true },
  component: () => (
    <AulasSection>
      <Outlet />
    </AulasSection>
  ),
});
